import { getCurrentInstance } from "vue";

export function findRootContext() {
  let ctx = getCurrentInstance();
  while (ctx.parent) {
    ctx = ctx.parent;
  }
  return ctx;
}
